import classnames from 'classnames';
import React from 'react';
import Input from "../../Input/Input";
import FeedbackModalRating from "./FeedbackModalRating";
import FeedbackModalSubtitle from "./FeedbackModalSubtitle";

var FeedbackModalBody = function FeedbackModalBody(_ref) {
  var commentIncluded = _ref.commentIncluded,
      commentPlaceholder = _ref.commentPlaceholder,
      commentRequired = _ref.commentRequired,
      commentSubtitle = _ref.commentSubtitle,
      commentValidationError = _ref.commentValidationError,
      highRatingText = _ref.highRatingText,
      lowRatingText = _ref.lowRatingText,
      ratingIncluded = _ref.ratingIncluded,
      ratingRequired = _ref.ratingRequired,
      ratingSubtitle = _ref.ratingSubtitle,
      ratingValidationError = _ref.ratingValidationError,
      setRating = _ref.setRating,
      setComment = _ref.setComment;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FeedbackModalSubtitle, {
    visible: ratingIncluded,
    required: ratingRequired,
    text: ratingSubtitle,
    labelClassNames: classnames({
      'js-rating-subtitle': true,
      'text-danger': ratingRequired
    })
  }), ratingIncluded && /*#__PURE__*/React.createElement(FeedbackModalRating, {
    highRatingText: highRatingText,
    lowRatingText: lowRatingText,
    ratingValidationError: ratingValidationError,
    setRating: setRating
  }), /*#__PURE__*/React.createElement(FeedbackModalSubtitle, {
    visible: commentIncluded,
    required: commentRequired,
    text: commentSubtitle,
    labelClassNames: classnames({
      'js-rating-subtitle': true,
      'text-danger': commentRequired
    })
  }), commentIncluded && /*#__PURE__*/React.createElement(Input, {
    className: "js-comment",
    placeholder: commentPlaceholder,
    rows: 5,
    type: "textarea",
    onChange: function onChange(e) {
      return setComment(e.target.value);
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "text-danger"
  }, commentValidationError));
};

FeedbackModalBody.displayName = "FeedbackModalBody";
export default FeedbackModalBody;